import { AvlPair } from '#migration/migration-avl'
import { useAvlRavMigration } from '#migration/migration-avl.rav'
import { Button } from 'apprise-ui/button/button'
import { FileBox } from 'apprise-ui/filebox/filebox'
import { Form } from 'apprise-ui/form/form'
import { SliderBox } from 'apprise-ui/sliderbox/slider'
import { saveAs } from "file-saver"
import { useState } from 'react'




export const LegacyAvlRavImport = () => {

    const save = (records: AvlPair[], title: string) => saveAs(new Blob([records.map(r => 
        
        `${r.uvi}\t${JSON.stringify(r.patch)}`
    
    ).join("\n")], { type: 'text/csv' }), title)


    const [migrationFile, migrationFileSet] = useState<File | undefined>()
  
    const [migrationSize, migrationsSizeSet] = useState<number | undefined>(10)
  
    const migration = useAvlRavMigration(migrationSize)


    const migrate = async () => {

        const outcome = await migration({ file: migrationFile! })

        if (outcome.issues.length)
            console.error(outcome)

       save(outcome.data, `${new Date().toISOString()} avl rav migration (${outcome.data.length}).csv`)
    }


    return <Form>

        <FileBox<File> maxSizeMb={50} multi={false} label='Generate From Legacy' msg='Upload a dump of the legacy db.' descriptorOf={f => f} onChange={files => migrationFileSet(files?.[0])}>
            {migrationFile}
        </FileBox>

        <SliderBox enabled={!!migrationFile} max={100000} marks={{ 100000: 'All' }} step={10} onChange={num => migrationsSizeSet(num ?? 0)}>
            {migrationSize}
        </SliderBox>

        <Button enabled={!!migrationFile} size='small' type='primary' onClick={migrate}>Migrate Records</Button>


    </Form>

}